__webpack_require__.p = "/county-domain-frontend/village_platform/";